module.exports = "/_next/static/images/08-505e16d16c952bf228cc6aea05afc4ac.png";